import { render } from "./ProfessionalExperience.vue?vue&type=template&id=65b67cf8&scoped=true"
import script from "./ProfessionalExperience.vue?vue&type=script&lang=js"
export * from "./ProfessionalExperience.vue?vue&type=script&lang=js"

import "./ProfessionalExperience.vue?vue&type=style&index=0&id=65b67cf8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-65b67cf8"

export default script